import { List, Map } from 'immutable';

const parentDeclaration = Map({
  loading: true,
  data: null,
  error: null,
});

const ndfl2 = Map({
  loading: false,
  data: List(),
  error: null,
});

const draftSubmit = Map({
  fetching: false,
  error: null,
});

const draftXml = Map({
  loading: true,
  error: null,
  data: null,
});

export default Map({
  initialized: false, // common scenario initialized
  loading: false, // common loading flag
  draft: null, // draft model
  error: null, // common error
  mode: null, // current draft mode
  parentDeclaration, // parent declaration model
  ndfl2, // ndfl2 list
  draftSubmit, // draft saving state,
  draftXml, // draft xml,
  declarationSubmitted: false, // declaration submit state,
  stepFetching: false,
});
